import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminPanel from './pages/admin-panel';
import BrandDashboard from './pages/brand-dashboard';
import LoginScreen from './pages/login-screen';
import UserDashboard from './pages/user-dashboard';
import UserOnboardingScreen from './pages/user-onboarding-screen';
import TransactionSubmissionScreen from './pages/transaction-submission-screen';
import AuthCallback from './pages/auth-callback';
import AuthenticationGuard from './components/ui/AuthenticationGuard';
import ProfileVerificationScreen from './pages/profile-verification-screen';
import InfluencerAnalyticsScreen from './pages/influencer-analytics-screen';
import SocialCentsCardScreen from './pages/social-cents-card-screen';
import CardApplicationFormScreen from './pages/card-application-form-screen';
import CardApplicationStatusScreen from './pages/card-application-status-screen';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AuthenticationGuard requiredRole="admin"><AdminPanel /></AuthenticationGuard>} />
        <Route path="/admin-panel" element={<AuthenticationGuard requiredRole="admin"><AdminPanel /></AuthenticationGuard>} />
        <Route path="/brand-dashboard" element={<AuthenticationGuard><BrandDashboard /></AuthenticationGuard>} />
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/user-dashboard" element={<AuthenticationGuard><UserDashboard /></AuthenticationGuard>} />
        <Route path="/user-onboarding-screen" element={<AuthenticationGuard><UserOnboardingScreen /></AuthenticationGuard>} />
        <Route path="/transaction-submission-screen" element={<AuthenticationGuard><TransactionSubmissionScreen /></AuthenticationGuard>} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/profile-verification-screen" element={<AuthenticationGuard><ProfileVerificationScreen /></AuthenticationGuard>} />
        <Route path="/influencer-analytics-screen" element={<AuthenticationGuard><InfluencerAnalyticsScreen /></AuthenticationGuard>} />
        <Route path="/social-cents-card-screen" element={<AuthenticationGuard><SocialCentsCardScreen /></AuthenticationGuard>} />
        <Route path="/card-application-form-screen" element={<AuthenticationGuard requiredRole="influencer"><CardApplicationFormScreen /></AuthenticationGuard>} />
        <Route path="/card-application-status-screen" element={<AuthenticationGuard requiredRole="influencer"><CardApplicationStatusScreen /></AuthenticationGuard>} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
